import {
  Component,
  inject,
  input,
  signal,
  computed,
} from '@angular/core';

import { RouterLink, RouterLinkActive } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { WizardFormSubmitService } from '../../services/wizard-form-submit/wizard-form-submit.service';
import { ButtonComponent } from '@mic-ac/ui-kit';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../services/auth-service/auth-service.service';
import { env } from '../../../../environments/environment';
import packageJson from '../../../../../package.json';
import { HOME_ROUTE } from '../../../app-route-paths';
import { NavbarUiService } from './navbar-ui.service';

type NavItem = {
  label: string | any;
  path: string;
  loggedIn?: boolean;
  exact?: boolean;
};

@Component({
    selector: 'app-navbar',
    imports: [
    RouterLink,
    RouterLinkActive,
    ReactiveFormsModule,
    ButtonComponent
],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.css',
})
export class NavbarComponent {
  readonly homeRoute = HOME_ROUTE;

  // services
  #authService = inject(AuthServiceService);
  #router = inject(Router);
  #navbarUi = inject(NavbarUiService);

  // component variables
  show = signal(false);
  mobileMenuOpen = this.#navbarUi.mobileMenuOpen;
  logoNavbar = input('');
  logoLinkedin = input('');
  logoUpperBar = input('');

  appVersion = signal(packageJson.version);
  baseUrl = signal(env.api.baseUrl);

  loginValue = computed(() => {
    if (this.#authService.user() !== null) return 'Logout';
    if (this.#authService.iamOnlyUser()) return 'IamOnly';
    return 'Area Riservata';
  });
  tempUsername = computed(() => {
    const u = this.#authService.user();
    return u ? `${u.element.cognome} ${u.element.nome}` : '';
  });

  isIamOnlyUser = computed(() => this.#authService.iamOnlyUser());
  isAuthenticated = computed(
    () => this.#authService.user() !== null || this.#authService.iamOnlyUser(),
  );
  visibleNavItems = computed(() => this.navItems().filter(item => item.loggedIn === true));
  mobileLogoIcon = 'assets/icons/favicon.svg';

  // scroll variables
  isScrolled = signal(false);
readonly userMenuOpen = signal(false);
 setUserMenuOpen(v: boolean): void {
  if (this.userMenuOpen() !== v) {
    this.userMenuOpen.set(v);
  }
}

  onUserMenuToggle(event: Event): void {
  const el = event.target as HTMLDetailsElement;
  this.setUserMenuOpen(el.open);
}

  open() {
    this.show.set(true);
  }
  close() {
    this.show.set(false);
  }

  navItems = input<NavItem[]>([]);

  // drop down button logic

  toggleUserMenu(): void {
    this.userMenuOpen.update((v) => !v);
  }

  closeUserMenu(): void {
    this.userMenuOpen.set(false);
  }



  goToRegister() {
    this.#router.navigate(['/register']);
  }

  login() {
    const v = this.loginValue();
    if (v === 'Logout' || v === 'IamOnly') {
      this.#authService.logout();
    } else {
      this.#authService.login();
    }
  }

  // label shown on the trigger button
  buttonLabel = computed(() => {
    const v = this.loginValue();
    if (v === 'IamOnly') return 'Ciao Utente';
    if (v === 'Logout') return this.tempUsername();
    return 'Area Riservata';
  });

  // classe on the trigger button
  buttonClasse = computed(() =>
    this.loginValue() === 'Area Riservata' ? 'primary custom-button-default' : 'button-link custom-button-sm-user-no-border'
  );

  // menu options for dpac-button
  menuOptions = computed(() => {
    const v = this.loginValue();
    if (v === 'IamOnly') {
      return [
        { label: 'Completa il tuo profilo', value: 'register', classe: 'boxed' },
        { label: 'Logout', value: 'login', classe: 'menu-title' },
      ];
    }
    if (v === 'Logout') {
      return [{ label: 'Logout', value: 'login', classe: 'menu-title' }];
    }
    return [
      { label: 'Accedi',     value: 'login',    classe: 'menu-title' },
      { label: 'Registrati', value: 'register', classe: 'boxed' },
    ];
  });

  onMenuOptionSelect(option: any): void {
    if (!option) return;
    if (option.value === 'login') {
      this.login();
    } else if (option.value === 'register') {
      this.goToRegister();
    }
  }

  toggleMobileMenu(): void {
    this.#navbarUi.toggleMobileMenu();
  }

  closeMobileMenu(): void {
    this.#navbarUi.closeMobileMenu();
  }

  mobileLogin(): void {
    this.closeMobileMenu();
    this.#authService.login();
  }

  mobileLogout(): void {
    this.closeMobileMenu();
    this.#authService.logout();
  }

  mobileRegister(): void {
    this.closeMobileMenu();
    this.goToRegister();
  }
}
